// src/components/common/DeployButton.js
import React from 'react';

const DeployButton = ({ onClick, isLoading }) => {
    return (
        <button
            onClick={onClick}

            className={`bg-[#C07AF6] text-white lg:px-8 lg:py-3 py-2 px-4 my-5 rounded-full transition-all text-md lg:text-lg flex items-center justify-center gap-2
                ${isLoading
                    ? 'opacity-75 cursor-not-allowed'
                    : 'hover:bg-[#B15AE6] hover:shadow-md hover:shadow-[#C07AF6]/20 hover:-translate-y-0.5'
                }`}
            disabled={isLoading}
        >
            {isLoading ? (
                <>
                    <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Deploying...
                </>
            ) : (
                <>
                    <span>🛠️</span>
                    Deploy Contract
                </>
            )}
        </button>
    );
};

export default DeployButton;